"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.PricingCatalogBuilder = exports.PricingCatalog = exports.PriceAccessory = exports.PricePiece = void 0;
var core_designer_domain_1 = require("@jewelutions/core-designer-domain");
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var PricePiece = /** @class */ (function () {
    function PricePiece() {
    }
    PricePiece.singleCurrencyOf = function (pricePieces) {
        if (pricePieces.length === 0)
            throw new core_common_domain_1.Exception("Cannot obtain the currency from an empty array of price pieces");
        var currencyOfFirstItem = pricePieces[0].price.currency;
        /* Sanity check */
        for (var _i = 0, pricePieces_1 = pricePieces; _i < pricePieces_1.length; _i++) {
            var pricePiece = pricePieces_1[_i];
            if (pricePiece.price.currency !== currencyOfFirstItem)
                throw new core_common_domain_1.Exception("Cannot obtain a single currency because the price piece array has different currencies and I cannot decide which one is the \"right one\". The array is : " + JSON.stringify(pricePieces));
        }
        return currencyOfFirstItem;
    };
    PricePiece.findPricePiece = function (pricePieces, matchPieceReference) {
        return pricePieces.find(function (p) { return core_designer_domain_1.PieceReference.identical(p.pieceReference, matchPieceReference); });
    };
    return PricePiece;
}());
exports.PricePiece = PricePiece;
var PriceAccessory = /** @class */ (function () {
    function PriceAccessory() {
    }
    PriceAccessory.singleCurrencyOf = function (priceAccessories) {
        if (priceAccessories.length === 0)
            throw new core_common_domain_1.Exception("Cannot obtain the currency from an empty array of price accessories");
        var currencyOfFirstItem = priceAccessories[0].price.currency;
        /* Sanity check */
        for (var _i = 0, priceAccessories_1 = priceAccessories; _i < priceAccessories_1.length; _i++) {
            var priceAccessory = priceAccessories_1[_i];
            if (priceAccessory.price.currency !== currencyOfFirstItem)
                throw new core_common_domain_1.Exception("Cannot obtain a single currency because the price accessory array has different currencies and I cannot decide which one is the \"right one\". The array is : " + JSON.stringify(priceAccessories));
        }
        return currencyOfFirstItem;
    };
    PriceAccessory.findPriceAccessory = function (priceAccessories, matchAccessoryReference) {
        return priceAccessories.find(function (p) {
            return core_designer_domain_1.AccessoryReference.identical(p.accessoryReference, matchAccessoryReference);
        });
    };
    return PriceAccessory;
}());
exports.PriceAccessory = PriceAccessory;
var PricingCatalog = /** @class */ (function () {
    function PricingCatalog() {
    }
    PricingCatalog.replaceAccessoryPricingByCurrencyInCatalogs = function (pricingCatalogs, newAccessoryPrices) {
        var currency = PriceAccessory.singleCurrencyOf(newAccessoryPrices);
        var existingPricingCatalog = pricingCatalogs.find(function (pc) { return pc.currency === currency; });
        var builder = existingPricingCatalog === undefined
            ? PricingCatalogBuilder.initiateWithEmptyPrices(currency)
            : PricingCatalogBuilder.initiateWithPricingCatalog(existingPricingCatalog);
        var updatedPricingCatalog = builder
            .clearPriceAccessories()
            .addPriceAccessories(newAccessoryPrices)
            .build();
        pricingCatalogs = pricingCatalogs.filter(function (pc) { return pc.currency !== updatedPricingCatalog.currency; });
        pricingCatalogs.push(updatedPricingCatalog);
        return pricingCatalogs;
    };
    PricingCatalog.replacePiecePricingByCurrencyInCatalogs = function (pricingCatalogs, newPiecePrices) {
        var currency = PricePiece.singleCurrencyOf(newPiecePrices);
        var existingPricingCatalog = pricingCatalogs.find(function (pc) { return pc.currency === currency; });
        var builder = existingPricingCatalog === undefined
            ? PricingCatalogBuilder.initiateWithEmptyPrices(currency)
            : PricingCatalogBuilder.initiateWithPricingCatalog(existingPricingCatalog);
        var updatedPricingCatalog = builder
            .clearPricePieces()
            .addPricePieces(newPiecePrices)
            .build();
        pricingCatalogs = pricingCatalogs.filter(function (pc) { return pc.currency !== updatedPricingCatalog.currency; });
        pricingCatalogs.push(updatedPricingCatalog);
        return pricingCatalogs;
    };
    return PricingCatalog;
}());
exports.PricingCatalog = PricingCatalog;
var PricingCatalogBuilder = /** @class */ (function () {
    function PricingCatalogBuilder(initialPricingCatalog) {
        this.catalog = {
            currency: core_common_domain_1.Currency.EUR,
            pieces: [],
            accessories: []
        };
        this.catalog = initialPricingCatalog;
        return this;
    }
    PricingCatalogBuilder.initiateWithEmptyPrices = function (initialCurrency) {
        return new PricingCatalogBuilder({
            currency: initialCurrency,
            pieces: [],
            accessories: []
        });
    };
    PricingCatalogBuilder.initiateWithPricingCatalog = function (initialPricingCatalog) {
        return new PricingCatalogBuilder(initialPricingCatalog);
    };
    PricingCatalogBuilder.prototype.build = function () {
        return this.catalog;
    };
    PricingCatalogBuilder.prototype.addPricePiece = function (newPricePiece) {
        if (newPricePiece.price.currency !== this.catalog.currency)
            throw new core_common_domain_1.Exception("Cannot add piece price " + JSON.stringify(newPricePiece) + " because it has a different currency than the pricing catalog currency " + this.catalog.currency);
        this.catalog.pieces.push(newPricePiece);
        return this;
    };
    PricingCatalogBuilder.prototype.addPricePieces = function (newPricePieces) {
        var newPiecesCurrency = PricePiece.singleCurrencyOf(newPricePieces);
        if (newPiecesCurrency !== this.catalog.currency)
            throw new core_common_domain_1.Exception("Cannot add piece prices " + JSON.stringify(newPricePieces) + " because it has a different currency than the pricing catalog currency " + this.catalog.currency);
        for (var _i = 0, newPricePieces_1 = newPricePieces; _i < newPricePieces_1.length; _i++) {
            var newPiecePrice = newPricePieces_1[_i];
            this.addPricePiece(newPiecePrice);
        }
        return this;
    };
    PricingCatalogBuilder.prototype.setAllPricePiecesAmountToValue = function (newAmount) {
        this.catalog.pieces = this.catalog.pieces.map(function (piece) {
            return __assign(__assign({}, piece), { price: __assign(__assign({}, piece.price), { amount: newAmount }) });
        });
        return this;
    };
    PricingCatalogBuilder.prototype.clearPricePieces = function () {
        this.catalog.pieces = [];
        return this;
    };
    PricingCatalogBuilder.prototype.addPriceAccessory = function (newPriceAccessory) {
        if (newPriceAccessory.price.currency !== this.catalog.currency)
            throw new core_common_domain_1.Exception("Cannot add accessory price " + JSON.stringify(newPriceAccessory) + " because it has a different currency than the pricing catalog currency " + this.catalog.currency);
        this.catalog.accessories.push(newPriceAccessory);
        return this;
    };
    PricingCatalogBuilder.prototype.addPriceAccessories = function (newPriceAccessories) {
        var newAccessoriesCurrency = PriceAccessory.singleCurrencyOf(newPriceAccessories);
        if (newAccessoriesCurrency !== this.catalog.currency)
            throw new core_common_domain_1.Exception("Cannot add accessory prices " + JSON.stringify(newPriceAccessories) + " because it has a different currency than the pricing catalog currency " + this.catalog.currency);
        for (var _i = 0, newPriceAccessories_1 = newPriceAccessories; _i < newPriceAccessories_1.length; _i++) {
            var newAccessoryPrice = newPriceAccessories_1[_i];
            this.addPriceAccessory(newAccessoryPrice);
        }
        return this;
    };
    PricingCatalogBuilder.prototype.setAllPriceAccessoriesAmountToValue = function (newAmount) {
        this.catalog.accessories = this.catalog.accessories.map(function (accessory) {
            return __assign(__assign({}, accessory), { price: __assign(__assign({}, accessory.price), { amount: newAmount }) });
        });
        return this;
    };
    PricingCatalogBuilder.prototype.clearPriceAccessories = function () {
        this.catalog.accessories = [];
        return this;
    };
    PricingCatalogBuilder.prototype.multiply = function (factor) {
        this.catalog = {
            currency: this.catalog.currency,
            pieces: this.catalog.pieces.map(function (p) {
                return {
                    pieceReference: p.pieceReference,
                    price: core_common_domain_1.Money.multiply(p.price, factor)
                };
            }),
            accessories: this.catalog.accessories.map(function (a) {
                return {
                    accessoryReference: a.accessoryReference,
                    price: core_common_domain_1.Money.multiply(a.price, factor)
                };
            })
        };
        return this;
    };
    PricingCatalogBuilder.prototype.updatePiecePricingWithMarkerPrice = function (pieceId, pieceModels, markerPrice) {
        if (markerPrice.currency !== this.catalog.currency)
            throw new core_common_domain_1.Exception("Cannot update piece price with marker price " + JSON.stringify(markerPrice) + " because it has a different currency than the pricing catalog currency " + this.catalog.currency);
        /* Keep only the piece prices that match the pieceId and possible configurations of it => remove piece pricing for other (piece, pieceConfiguration) combinations. */
        var resultingPiecePricing = this.catalog.pieces.filter(function (piecePrice) {
            return piecePrice.pieceReference.pieceId === pieceId &&
                pieceModels.find(function (newModel) { return newModel.id === piecePrice.pieceReference.pieceModelId; }) !== undefined;
        });
        var missingPiecePricing = [];
        var _loop_1 = function (pieceModel) {
            for (var _i = 0, _a = pieceModel.availableConfigurations; _i < _a.length; _i++) {
                var possiblePieceConfiguration = _a[_i];
                if (resultingPiecePricing.find(function (oldPiecePricing) {
                    return oldPiecePricing.pieceReference.pieceId === pieceId &&
                        oldPiecePricing.pieceReference.pieceModelId === pieceModel.id;
                }) === undefined) {
                    /* New pieceId,possiblePieceConfiguration not yet present in the piece pricing => add it */
                    missingPiecePricing.push({
                        pieceReference: {
                            pieceId: pieceId,
                            pieceModelId: pieceModel.id,
                            pieceConfiguration: possiblePieceConfiguration
                        },
                        price: markerPrice
                    });
                }
            }
        };
        for (var _i = 0, pieceModels_1 = pieceModels; _i < pieceModels_1.length; _i++) {
            var pieceModel = pieceModels_1[_i];
            _loop_1(pieceModel);
        }
        resultingPiecePricing.push.apply(resultingPiecePricing, missingPiecePricing);
        this.catalog.pieces = resultingPiecePricing;
        return this;
    };
    PricingCatalogBuilder.prototype.updateAccessoryPricingWithMarkerPrice = function (accessoryId, accessoryModels, markerPrice) {
        if (markerPrice.currency !== this.catalog.currency)
            throw new core_common_domain_1.Exception("Cannot update accessory price with marker price " + JSON.stringify(markerPrice) + " because it has a different currency than the pricing catalog currency " + this.catalog.currency);
        /* Keep only the accessory prices that match the accessoryId and possible configurations of it => remove accessory pricing for other (accessory, pieceConfiguration) combinations. */
        var resultingAccessoryPricing = this.catalog.accessories.filter(function (accessoryPrice) {
            return accessoryPrice.accessoryReference.accessoryId === accessoryId &&
                accessoryModels.find(function (newModel) { return newModel.id === accessoryPrice.accessoryReference.accessoryModelId; }) !== undefined;
        });
        var missingAccessoryPricing = [];
        var _loop_2 = function (accessoryModel) {
            for (var _i = 0, _a = accessoryModel.availableConfigurations; _i < _a.length; _i++) {
                var possibleAccessoryConfiguration = _a[_i];
                if (resultingAccessoryPricing.find(function (oldAccessoryPricing) {
                    return oldAccessoryPricing.accessoryReference.accessoryId === accessoryId &&
                        accessoryModel.id === oldAccessoryPricing.accessoryReference.accessoryModelId;
                }) === undefined) {
                    /* New accessoryId,possibleAccessoryConfiguration not yet present in the accessory pricing => add it */
                    missingAccessoryPricing.push({
                        accessoryReference: {
                            accessoryId: accessoryId,
                            accessoryModelId: accessoryModel.id,
                            accessoryConfiguration: possibleAccessoryConfiguration
                        },
                        price: markerPrice
                    });
                }
            }
        };
        for (var _i = 0, accessoryModels_1 = accessoryModels; _i < accessoryModels_1.length; _i++) {
            var accessoryModel = accessoryModels_1[_i];
            _loop_2(accessoryModel);
        }
        resultingAccessoryPricing.push.apply(resultingAccessoryPricing, missingAccessoryPricing);
        this.catalog.accessories = resultingAccessoryPricing;
        return this;
    };
    return PricingCatalogBuilder;
}());
exports.PricingCatalogBuilder = PricingCatalogBuilder;
